import { createFileRoute } from '@tanstack/react-router';

import {
  seoAuditsQueryOptions,
  seoIssueListParams,
  seoIssueSearchSchema,
  SeoIssuesPage,
  seoIssuesQueryOptions,
} from '@/features/seo';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/seo')({
  staticData: { crumb: 'common:nav.seo', tours: ['content.seo'] },
  validateSearch: seoIssueSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = Promise.all([
      context.queryClient
        .query({
          ...seoIssuesQueryOptions(params.storeId, seoIssueListParams(deps)),
          staleTime: 'static',
        })
        .catch(() => undefined),
      context.queryClient
        .query({ ...seoAuditsQueryOptions(params.storeId), staleTime: 'static' })
        .catch(() => undefined),
    ]);
    // Filter, sort and page changes on the list must not wait for the fetch, or a second pick in
    // the filter would build on the stale URL. The page's own query shows the previous rows.
    if (cause !== 'stay') await prefetch;
  },
  component: SeoIssuesPage,
});
